import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { api } from "../utils/apiHelper";
import "../styles/StripePay.css";

const StripePay = ({ total, cartItems, authUser, onPaymentSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [name, setName] = useState("");
  const [processing, setProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);

    try {
      const cents = Math.round(total * 100);
      const payload = {
        amount: cents,
        userId: authUser._id,
        cartItems,
        email: authUser.email,
      };

      const response = await api("/create-payment-intent", "POST", payload);

      if (!response?.clientSecret) {
        setError("Unable to initialize payment.");
        setProcessing(false);
        return;
      }

      const cardElement = elements.getElement(CardElement);

      const result = await stripe.confirmCardPayment(response.clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: { name },
        },
      });

      if (result.error) {
        setError(result.error.message);
        setProcessing(false);
        return;
      }

      if (result.paymentIntent.status === "succeeded") {
        // ✅ Attempt to create ZIPs first
        const zipResponse = await api("/generate-purchase-zips", "POST", {
          userId: authUser._id,
          receipts: response.receipts,
        });

        if (zipResponse?.success) {
          await api("/clear-cart", "POST", { userId: authUser._id });
          console.log("🧹 Cart successfully cleared.");
        } else {
          setError("Payment succeeded, but file packaging failed.");
          setProcessing(false);
          return;
        }

        setSucceeded(true);
        setProcessing(false);
        setName("");
        cardElement.clear();

        if (typeof onPaymentSuccess === "function") {
          onPaymentSuccess(response.message || "Payment successful!");
        }
      }
    } catch (err) {
      console.error("Payment error:", err);
      setError("An error occurred during payment.");
      setProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="stripe-pay-form">
      <h3>Payment Details</h3>

      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Name on card"
        required
        className="stripe-pay-form-input"
      />

      <CardElement className="CardElement" />

      <button type="submit" className="stripe-pay-form-button" disabled={processing || succeeded}>
        {processing ? "Processing..." : `Pay $${total.toFixed(2)}`}
      </button>

      {error && <div className="error-message">{error}</div>}
      {succeeded && <div className="success-message">✅ Payment successful!</div>}
    </form>
  );
};

export default StripePay;
